import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App";
import { ApplicationServicesProvider } from "./common/ApplicationServicesContext";
import ErrorBoundary from "./common/routeWrappers/ErrorBoundary";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <ApplicationServicesProvider>
            <App />
        </ApplicationServicesProvider>
    </ErrorBoundary>
);
